import {extend, override} from 'flarum/common/extend';
import app from 'flarum/forum/app';
import BasicEditorDriver from 'flarum/common/utils/BasicEditorDriver';
import DiscussionComposer from 'flarum/forum/components/DiscussionComposer';
import FormGroup from './components/FormGroup';

// Use a separate function from the main composer changes so we can change its priority
export default function () {
    const PrivateDiscussionComposer = (flarum.extensions['fof-byobu'] as any)?.discussions?.PrivateDiscussionComposer;

    if (PrivateDiscussionComposer) {
        // Since we can't know if this is Byobu in the initAttrs extend below, we will add an unused key to the attrs that can be read later
        override(PrivateDiscussionComposer, 'initAttrs', function (original, attrs: any) {
            attrs['data-formulaire-byobu'] = 1;

            return original(attrs);
        });
    }

    extend(DiscussionComposer, 'initAttrs', function (returnValue, attrs) {
        if (!app.forum.attribute('formulaireUniformComposerLayout')) {
            return;
        }

        if (attrs['data-formulaire-byobu'] && app.forum.attribute('formulaireNoByobuFields')) {
            return;
        }

        attrs.className += ' Formulaire-uniform-layout';
    });

    extend(DiscussionComposer.prototype, 'headerItems', function (items) {
        if (!app.forum.attribute('formulaireUniformComposerLayout')) {
            return;
        }

        if (app.forum.attribute('formulaireNoByobuFields') && this._isByobuComposer) {
            return;
        }

        if (items.has('tags')) {
            const tagSelector = items.get('tags');

            items.setContent('tags', m(FormGroup, {
                label: m('label', app.translator.trans('kilowhat-formulaire.forum.discussion-composer.field.tags')),
                validationErrors: this.formulaireValidationErrors.tags,
            }, m('.FormControl.FormulaireTagFormControl', tagSelector)));
        }

        Object.keys(items.toObject()).forEach(key => {
            if (key.indexOf('taxonomy-') !== 0) {
                return;
            }

            const taxonomyInput = items.get(key);

            items.setContent(key, m(FormGroup, {
                label: m('label', (taxonomyInput && taxonomyInput.attrs['data-taxonomy-name']) || '?'),
                validationErrors: this.formulaireValidationErrors.tags,
            }, m('.FormControl.FormulaireTagFormControl', taxonomyInput)));
        });

        if (items.has('polls')) {
            const tagSelector = items.get('polls');

            items.setContent('polls', m(FormGroup, {
                label: m('label', app.translator.trans('kilowhat-formulaire.forum.discussion-composer.field.poll')),
            }, m('.FormControl.FormulaireTagFormControl', tagSelector)));
        }

        items.setContent('discussionTitle', m(FormGroup, {
            label: m('label', {
                for: 'discussionComposerTitle',
            }, app.translator.trans('kilowhat-formulaire.forum.discussion-composer.field.title')),
            validationErrors: this.formulaireValidationErrors.title,
        }, m('input#discussionComposerTitle.FormControl', {
            bidi: this.title,
            placeholder: this.attrs.titlePlaceholder,
            disabled: this.attrs.disabled,
            onkeydown: this.onkeydown.bind(this),
        })));

        items.add('formulaireContentLabel', m(FormGroup, {
            label: m('label', {
                for: 'discussionComposerContent',
            }, app.translator.trans('kilowhat-formulaire.forum.discussion-composer.field.content')),
        }), -10000); // Must be at the very end since it's for the text editor which is outside of the header items
    });

    extend(BasicEditorDriver.prototype, 'build', function () {
        if (!app.forum.attribute('formulaireUniformComposerLayout')) {
            return;
        }

        // Only needed to connect the new label to the existing field
        // Ideally we shouldn't apply this when Byobu support is disabled, but it's not easy to detect it here
        // Since there is no ID by default, adding one when not used should not lead to any issue
        this.el.id = 'discussionComposerContent';
    });
}
